module.exports = __webpack_public_path__ + "img/bild-h.758bf56e.png";